/* eslint-disable import/no-extraneous-dependencies, arrow-body-style,object-curly-newline */
/* global React */
import DocHoc from 'platform/react/hoc/pubsub/doc'
import Section from 'ui/Element/Acl/Section'

const AclSubbedSection = DocHoc(React.forwardRef(Section))

export default AclSubbedSection
